import { setWalletDepositModalOpen } from "../../modules/modals/deposit-withdraw/redux/walletDepositModalSlice"
import {
  setSelectedCoinId,
  setDepositData,
  setDepositAddress
} from "../../redux/slices/depositSlice"
import { store } from "../../redux/store"
import { _getDepositAddress } from "../../redux/actions"

export const handleDeposit = (coinId) => {
  // First, dispatch the action to set the selected coin ID
  store.dispatch(setSelectedCoinId(coinId))

  // Then find the coin data to store along with the ID
  const state = store.getState()
  const currencies = state.currencies.value
  const coinData = currencies.find(currency => currency.id === coinId) || {}

  // Store the coin data for reference in the modal
  store.dispatch(setDepositData(coinData))
  store.dispatch(setWalletDepositModalOpen(true))
  // Fetch deposit address before opening modal
  // _getDepositAddress(
  //   {
  //     currency: coinId
  //   },
  //   (data) => {
  //     // Set the deposit address in the store
  //     store.dispatch(setDepositAddress(data))
  //     // Open the modal after getting the address
  //     store.dispatch(setWalletDepositModalOpen(true))
  //   },
  //   (err) => {
  //     console.error('Error fetching deposit address:', err)
  //     // Still open the modal even if address fetch fails
  //     store.dispatch(setWalletDepositModalOpen(true))
  //   }
  // )
}
